module.exports = __webpack_public_path__ + "img/h-2m.885417b0.jpg";